import React, { useEffect, useState } from "react";
import authHeader from "services/auth-header";
import API from "services/axios";

export default function QuickViewContact({
  selected,
  showModal,
  setShowModal,
}) {
  /*   All States
   ********************************************* */
  const [contactsData, setContactsData] = useState(null);
  const [shippingAddress, setShippingAddress] = useState(null);
  const [shipmentMethods, setShipmentMethods] = useState([]);

  /*   All Functions
   ********************************************* */

  // Resolved from the WO's shipmentMethod FK rather than a joined association:
  // this modal is opened from several QuickView call sites whose list payloads
  // don't all include the shippingMethod join, but the raw FK column is always
  // on the row.
  const shipmentMethodName = shipmentMethods.find(
    (method) => method.id === selected?.shipmentMethod,
  )?.shippingMethod;

  /*   All UseEffects
   ********************************************* */
  useEffect(() => {
    if (!showModal) return;
    let cancelled = false;
    (async () => {
      try {
        const { data } = await API.get("/shipmentmethods", {
          headers: authHeader(),
        });
        if (!cancelled) setShipmentMethods(data || []);
      } catch {
        // Just leaves the Shipping Method row blank -- every other field in
        // this modal still renders.
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [showModal]);

  useEffect(() => {
    if (selected && showModal) {
      let _contactsData =
        selected?.contactData && typeof selected?.contactData === "string"
          ? JSON.parse(selected?.contactData)
          : selected?.contactData;
      setContactsData(_contactsData);

      let _shippingAddress =
        selected?.shippingAddress &&
        typeof selected?.shippingAddress === "string"
          ? JSON.parse(selected?.shippingAddress)
          : selected?.shippingAddress;
      setShippingAddress(_shippingAddress);
    } else {
      setContactsData(null);
      setShippingAddress(null);
    }
  }, [selected, showModal]);
  return (
    <div>
      <div className="row mb-0 lh-sm">
        <div className="col-3 fw-bold text-nowrap">W-ID :</div>
        <div className="col-auto">{selected?.woId}</div>
      </div>
      <div className="row mb-0 lh-sm">
        <div className="col-3 fw-bold text-nowrap">Customer Name :</div>
        <div className="col-auto">{selected?.customerName}</div>
      </div>
      <div className="row mb-0 lh-sm">
        <div className="col-3 fw-bold text-nowrap">Job Name :</div>
        <div className="col-auto">{selected?.jobName}</div>
      </div>
      <div className="row mb-0 lh-sm">
        <div className="col-3 fw-bold text-nowrap">Sub Job :</div>
        <div className="col-auto">{selected?.subJobName}</div>
      </div>
      <hr className="my-2" />
      {contactsData && (
        <>
          <div className="row mb-0 lh-sm">
            <div className="col-3 fw-bold text-nowrap">First Name :</div>
            <div className="col-auto">{contactsData?.firstName}</div>
          </div>
          <div className="row mb-0 lh-sm">
            <div className="col-3 fw-bold text-nowrap">Last Name :</div>
            <div className="col-auto">{contactsData?.lastName}</div>
          </div>
          <div className="row mb-0 lh-sm">
            <div className="col-3 fw-bold text-nowrap">Email :</div>
            <div className="col-auto">{contactsData?.email}</div>
          </div>
          <div className="row mb-0 lh-sm">
            <div className="col-3 fw-bold text-nowrap">Phone :</div>
            <div className="col-auto">{contactsData?.phone}</div>
          </div>
          <div className="row mb-0 lh-sm">
            <div className="col-3 fw-bold text-nowrap">Department :</div>
            <div className="col-auto">{contactsData?.department}</div>
          </div>
        </>
      )}
      <hr className="my-2" />
      {shippingAddress && (
        <>
          <div className="row mb-0 lh-sm">
            <div className="col-3 fw-bold text-nowrap">Shipping Method :</div>
            <div className="col-auto">{shipmentMethodName || "-"}</div>
          </div>
          <div className="row mb-0 lh-sm">
            <div className="col-3 fw-bold text-nowrap">Address 1 :</div>
            <div className="col-auto">{shippingAddress?.addressLine1}</div>
          </div>
          <div className="row mb-0 lh-sm">
            <div className="col-3 fw-bold text-nowrap">Address 2 :</div>
            <div className="col-auto">{shippingAddress?.addressLine2}</div>
          </div>
          <div className="row mb-0 lh-sm">
            <div className="col-3 fw-bold text-nowrap">City :</div>
            <div className="col-auto">{shippingAddress?.city}</div>
          </div>
          <div className="row mb-0 lh-sm">
            <div className="col-3 fw-bold text-nowrap">State :</div>
            <div className="col-auto">{shippingAddress?.state}</div>
          </div>
          <div className="row mb-0 lh-sm">
            <div className="col-3 fw-bold text-nowrap">Zip Code :</div>
            <div className="col-auto">{shippingAddress?.zip}</div>
          </div>
        </>
      )}
    </div>
  );
}
